import {Distribution, _Distribution} from './distribution';

/**
 * Generated from com.dataiku.dip.eda.compute.distributions.Exponential
 */
export interface Exponential extends _Distribution {
    // PolyJson type
    type: 'exponential';
}

export function isExponential(toTest: Distribution): toTest is Exponential { return 'exponential' === toTest.type; }

export namespace Exponential {
    /**
     * Generated from com.dataiku.dip.eda.compute.distributions.Exponential$FittedExponential
     */
    export interface FittedExponential extends Distribution._FittedDistribution {
        rate: number;

        // PolyJson type
        type: 'exponential';
    }

    export function isFittedExponential(toTest: Distribution.FittedDistribution): toTest is FittedExponential { return 'exponential' === toTest.type; }
}